import { MORTGAGE_LIMITS } from "shared/CalculatorLimits";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getMortgageFormSchema = (t: TranslateFunction) =>
	z.object({
		propertyPrice: getAmountField(t, {
			min: MORTGAGE_LIMITS.propertyPriceMin,
			max: MORTGAGE_LIMITS.propertyPriceMax,
		}),
		years: z.number(),
		loanValue: z.number(),
	});
